import { REQUEST_STUDENTS, RECEIVE_STUDENTS, STUDENTS_ERROR } from '../actions/studentActions';

// const initialState = {
//     loading: false,
//     students: [],
//     error: null
// };

// In reducer initialState
const initialState = {
    loading: false,
    loaded: false,
    students: [],
    error: null
};

export default function studentReducer(state = initialState, action) {
    switch (action.type) {
        // case REQUEST_STUDENTS:
        //     return { ...state, loading: true, error: null };
        case RECEIVE_STUDENTS:
            return { ...state, loading: false, loaded: true, students: action.students };
        case RECEIVE_STUDENTS:
            return { ...state, loading: false, students: action.students };
        case STUDENTS_ERROR:
            return { ...state, loading: false, error: action.error, students: [] };
        default:
            return state;
    }
}